var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.792,
    height: 16.792,
    viewBox: "0 0 16.792 16.792",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 456"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 512",
    d: "M8.4 0a8.4 8.4 0 1 0 8.4 8.4A8.4 8.4 0 0 0 8.4 0zm.78 11.635H7.5V7.317h1.676zM8.336 6.6a.84.84 0 1 1 .84-.84.839.839 0 0 1-.84.84z",
    style: {
      fill: "#30c19a"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenInfo);
export default __webpack_public_path__ + "static/media/green-info.1ca5d06f3eb620d0774af61a392f77d0.svg";
export { ForwardRef as ReactComponent };